import React from "react";
import "./skeleton.css";

function PageSkeleton() {
  const skeletonBars = Array.from({ length: 20 });

  return (
    <div className="section-wrap mt-5 pb-20">
      <div className="w-1/2 max-w-[200px] h-10 animateSkl"></div>
      <div className="w-[80%] max-w-[350px]  mt-3 h-10 animateSkl"></div>
      <div className="grid grid-flow-row grid-cols-2  gap-5 mt-4">
        {skeletonBars.map((_, i) => (
          <div key={i} className="h-20 animateSkl"></div>
        ))}
      </div>
    </div>
  );
}

export default PageSkeleton;
